// extracted by mini-css-extract-plugin
export default {"title":"Terms_title__W3qyv","text":"Terms_text__VxhKm"};